import qs from "qs";

import { axiosWithAuth } from "helpers";
import { getTerminalSolutionBody } from "mappers";
import { TerminalSolutionCreateDto, TerminalSolutionEditDto } from "types/api";

export const applicationTerminalService = {
	addTerminalSolution,
	copyTerminalSolution,
	getTerminalList,
	getTerminalSolutionById,
	removeTerminalSolution,
	updateTerminalSolution,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 100;

function getTerminalList({
	page,
	sortBy,
	filters,
	applicationId,
}: {
	page: number;
	sortBy?: string;
	filters?: any;
	applicationId: string;
}) {
	const body = getTerminalSolutionBody({
		page,
		filters,
		sortBy,
		PAGE_SIZE,
	});

	const options = {
		method: "GET",
		params: body,
		url: `${API_URL}/api/applications/${applicationId}/terminal_solutions`,
		paramsSerializer: params =>
			qs.stringify(params, { arrayFormat: "repeat" }),
	};

	return axiosWithAuth(options);
}

function updateTerminalSolution(
	terminalId,
	data: TerminalSolutionEditDto,
	applicationId,
) {
	const options = {
		method: "PUT",
		url: `${API_URL}/api/applications/${applicationId}/terminal_solutions/${terminalId}`,
		data: JSON.stringify(data),
	};
	return axiosWithAuth(options);
}

function getTerminalSolutionById(id, applicationId) {
	const options = {
		url: `${API_URL}/api/applications/${applicationId}/terminal_solutions/${id}`,
	};
	return axiosWithAuth(options);
}

function addTerminalSolution(data: TerminalSolutionCreateDto) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/${data.application_id}/terminal_solutions`,
		data: JSON.stringify(data),
	};
	return axiosWithAuth(options);
}

function removeTerminalSolution(terminalId, applicationId) {
	const options = {
		method: "DELETE",
		url: `${API_URL}/api/applications/${applicationId}/terminal_solutions/${terminalId}`,
	};
	return axiosWithAuth(options);
}

function copyTerminalSolution(terminalId, applicationId) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/${applicationId}/terminal_solutions/${terminalId}/copy`,
	};
	return axiosWithAuth(options);
}
